export default {
  metadata: {
    version: '1.0.0',
    id: 'nudge-1.0.0',
    name: 'JDSNudgeContainer'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': [
          {
            'root-container': ['jds_nudge']
          }
        ]
      }
    ]
  },
  base: {
    popup: {
      priority: 70,
      passive: true
    },
    'popup-container': {
      'flex-direction': '{n_0}',
      size: '{n_1}',
      'padding-top': '{n_2}',
      'padding-right': '{n_3}',
      'padding-bottom': '{n_4}',
      'padding-left': '{n_5}'
    },
    'root-container': {
      'flex-direction': '{n_6}',
      'justify-content': '{n_7}',
      'align-items': '{n_8}',
      size: '{n_9}',
      gap: '{n_10}'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      'root-container': {
        value: {
          type: 'list',
          name: 'activeNudges',
          object: {
            title: 'string',
            description: 'string',
            primaryCTA: 'string',
            secondaryCTA: 'string',
            showClose: 'boolean',
            id: 'string',
            prefix: 'string'
          }
        }
      },
      jds_nudge: {
        prefix: {
          type: 'string',
          name: 'activeNudges.prefix'
        },
        title: {
          type: 'string',
          name: 'activeNudges.title'
        },
        description: {
          type: 'string',
          name: 'activeNudges.description'
        },
        primaryCTA: {
          type: 'string',
          name: 'activeNudges.primaryCTA'
        },
        secondaryCTA: {
          type: 'string',
          name: 'activeNudges.secondaryCTA'
        },
        showClose: {
          type: 'string',
          name: 'activeNudges.showClose'
        },
        id: {
          type: 'string',
          name: 'activeNudges.id'
        },
        suffix: {
          type: 'slot',
          name: 'activeNudges.suffix'
        }
      }
    },
    events: {
      jds_nudge: {
        onClose: 'onClose',
        onPrimaryClick: 'onPrimaryClick',
        onSecondaryClick: 'onSecondaryClick',
        onShow: 'onShow'
      }
    },
    a11y: {
      jds_nudge: {
        properties: {
          closeButtonAriaLabel: 'closeButtonAriaLabel',
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
